module.exports = __webpack_public_path__ + "static/media/logo.6ca027e5.png";